export default __webpack_public_path__ + "kubernetes.03898bdb.png";